export type { DividerProps } from './Divider'
export { Divider } from './Divider'
